module.exports = __webpack_public_path__ + "img/leo.e0ab3efe.png";